import { ChildProps } from '@/common/util/props'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Icon, { IconType } from '@/components/view/atoms/icon/Icon'

interface Props extends ChildProps {
  onClick?(): void
}

const Code = ({ children, onClick }: Props) => {
  return (
    <div className='group relative'>
      <pre className='text-on-bg-fill bg-fill-brand-active font-robot mt-2 overflow-auto rounded-lg px-4 py-3 text-sm leading-150 whitespace-pre-wrap'>
        {children}
      </pre>
      {onClick && (
        <span className='absolute top-2 right-2 rounded p-1 opacity-0 transition-opacity group-hover:opacity-100'>
          <Button square onClick={onClick} color={ButtonColor.SECONDARY}>
            <Icon type={IconType.COPY} />
          </Button>
        </span>
      )}
    </div>
  )
}

export default Code
